import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import Dialog, { DialogProps } from "@material-ui/core/Dialog";
import background from "assets/images/backgrounds/bg_main.jpg";
import { cssImportant } from "theme";
import DialogTransition from "./DialogTransition";
import clsx from "clsx";
import DialogCloseButton from "./DialogCloseButton";

const useStyles = makeStyles((theme: Theme) => {
    return createStyles({
        root: {
            position: "relative",
            "& img": {
                width: "100%",
            },
        },
        closeButton: {
            position: "absolute",
            top: -20,
            right: -20,
            zIndex: 100,
        },
        backdropRoot: {
            backgroundImage: `url(${background})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            opacity: 0.8 + cssImportant,
        },
    });
});

export interface IMediaDialogProps extends DialogProps {}

export default function MediaDialog(props: IMediaDialogProps) {
    const classes = useStyles();
    const { children, className, open, onClose = () => {}, ...rest } = props;

    return (
        <Dialog
            open={open}
            onClose={onClose}
            className={clsx(className, classes.root)}
            TransitionComponent={DialogTransition}
            fullWidth
            maxWidth="lg"
            scroll="body"
            PaperProps={{
                square: true,
                style: {
                    overflow: "unset",
                },
            }}
            BackdropProps={{
                classes: { root: open ? classes.backdropRoot : undefined },
            }}
            {...rest}
        >
            <div className={classes.closeButton}>
                <DialogCloseButton onClick={() => onClose({}, "backdropClick")} />
            </div>
            {children}
        </Dialog>
    );
}
